import classNames from 'classnames';
import { ReactNode } from 'react';

import { MediaitemModel, MediaitemUsageType } from '@models';
import { BackgroundJobActivityTarget } from '@models/backgroundActivities';
import { setupForDark } from '@theme';
import MediaitemInput from './MediaitemInput';
import MediaitemThumbnail from './MediaitemThumbnail';

const MediaitemFieldEditor = ({
  target,
  title,
  placeholder,
  value,
  onChange,
  allowedFileTypes,
  maxFileSize,
  mediaitemUsageType,
  onPlay
}: {
  target: BackgroundJobActivityTarget;
  title: ReactNode;
  placeholder: string;
  value: MediaitemModel | null;
  onChange: (mediaitemId: number) => void;
  allowedFileTypes?: string[];
  maxFileSize?: number;
  mediaitemUsageType: MediaitemUsageType;
  onPlay?: () => void;
}) => {
  const handleMediaitemUploaded = (mediaitemId: number) => onChange(mediaitemId);

  return (
    <div
      className={classNames(
        'flex flex-col rounded-sm px-sm pt-xxs pb-md',
        setupForDark('bg-primary')
      )}
    >
      <div className='flex flex-row items-center justify-between'>
        <div className={classNames('LS2M py-sm mb-xxs uppercase', setupForDark('text-tertiary'))}>
          {title}
        </div>
      </div>
      {value && (
        <div className='mb-sm'>
          <MediaitemThumbnail mediaitem={value} type='small' />
        </div>
      )}
      <MediaitemInput
        target={target}
        placeholder={placeholder}
        allowedFileTypes={allowedFileTypes}
        maxFileSize={maxFileSize}
        mediaitemUsageType={mediaitemUsageType}
        onUploaded={handleMediaitemUploaded}
      />
    </div>
  );
};

export default MediaitemFieldEditor;
